import { IsNotEmpty, IsISO8601 } from 'class-validator';

export class CalendarEventEditDatesOnlyDTO {
    
    @IsNotEmpty()
    @IsISO8601()
    from: string;

    @IsNotEmpty()
    @IsISO8601()
    to: string;

}
